import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-01bb0545")

_pushScopeId("data-v-01bb0545")
const _hoisted_1 = { class: "main-toolbar-end-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Button = _resolveComponent("Button")
  const _component_Menu = _resolveComponent("Menu")
  const _component_Menubar = _resolveComponent("Menubar")
  const _component_NotesArchive = _resolveComponent("NotesArchive")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Menubar, {
      model: _ctx.menubarItems,
      class: "main-toolbar-style"
    }, {
      start: _withId(() => []),
      end: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", {
            class: `status-indicator ${_ctx.statusMessageStyle}`
          }, [
            _withDirectives(_createVNode(_component_Avatar, {
              icon: `pi ${_ctx.statusIcon}`,
              class: "p-mr-2 ",
              size: "small",
              shape: "circle"
            }, null, 8, ["icon"]), [
              [
                _directive_tooltip,
                _ctx.statusMsg,
                void 0,
                { bottom: true }
              ]
            ])
          ], 2),
          _createVNode(_component_Button, {
            class: "nav-button p-button-icon-only p-button-rounded p-button-info p-button-outlined p-mr-2 avatar-icon",
            icon: _ctx.avatarBase64 || _ctx.defaultIcon,
            onClick: _ctx.onProfileButtonClick
          }, {
            default: _withId(() => [
              (_ctx.avatarBase64)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    alt: "avatar",
                    src: _ctx.avatarBase64,
                    style: {"width":"40px"}
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["icon", "onClick"]),
          _createVNode(_component_Menu, {
            id: _ctx.ariaId + '_overlay',
            ref: "menu",
            model: _ctx.profileMenuItems,
            popup: true
          }, null, 8, ["id", "model"])
        ])
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_OverlayPanel, {
      ref: "archiveOverlay",
      baseZIndex: -100,
      dismissable: false
    }, {
      default: _withId(() => [
        _createVNode("div", null, [
          _createVNode(_component_NotesArchive)
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
})